import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=de91daae&scoped=true&"
import script from "./arrow.vue?vue&type=script&lang=js&"
export * from "./arrow.vue?vue&type=script&lang=js&"
import style0 from "./arrow.vue?vue&type=style&index=0&id=de91daae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de91daae",
  null
  
)

export default component.exports